import { axios } from './axios';

export const getNutrientAnalysisInfo = async ({ recipe_id }: { recipe_id: string }) => {
  return axios
    .get<any>('/nutrient_analysis', {
      params: {
        recipe_id,
      },
    })
    .then((res) => res.data);
};
